import React, { useState, useEffect } from "react";
import { db, collection, addDoc } from "../utils/firebaseConfig";


const WaitlistForm = ({ sharedEmail }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: sharedEmail || "",
    phone: "",
    profession: "",
    agency: "",
    website: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    if (sharedEmail) {
      setFormData((prev) => ({ ...prev, email: sharedEmail })); // ✅ Sync shared email
    }
  }, [sharedEmail]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const docRef = await addDoc(collection(db, "waitlist"), {
        ...formData,
        timestamp: new Date(),
      });
      console.log("✅ Document written with ID:", docRef.id);
      setSuccessMessage("🎉 Successfully joined the waitlist! Beta instructions will be sent soon.");
      setFormData({ fullName: "", email: "", phone: "", profession: "", agency: "", website: "" });
    } catch (error) {
      console.error("❌ Error adding document:", error);
      setSuccessMessage("❌ Error joining waitlist. Please try again.");
    }

    setIsSubmitting(false);
  };

  const isRecruiter = formData.profession === "recruiter";

  return (
    <form onSubmit={handleSubmit} className="space-y-4 bg-gray-800 p-8 rounded-lg border border-gray-700">
      <input
        type="text"
        name="fullName"
        value={formData.fullName}
        onChange={handleChange}
        placeholder="Full Name"
        className="w-full p-3 rounded-lg bg-gray-900 border border-gray-700 text-white placeholder-gray-500 focus:border-purple-500 focus:ring-purple-500"
        required
      />
      <input
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        placeholder="Email Address"
        className="w-full p-3 rounded-lg bg-gray-900 border border-gray-700 text-white placeholder-gray-500 focus:border-purple-500 focus:ring-purple-500"
        required
      />
      <input
        type="tel"
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        placeholder="Phone Number"
        className="w-full p-3 rounded-lg bg-gray-900 border border-gray-700 text-white placeholder-gray-500 focus:border-purple-500 focus:ring-purple-500"
        required
      />
      <select
        name="profession"
        value={formData.profession}
        onChange={handleChange}
        className="w-full p-3 rounded-lg bg-gray-900 border border-gray-700 text-white focus:border-purple-500 focus:ring-purple-500"
        required
      >
        <option value="">Select Your Profession</option>
        <option value="rt">Travel RT</option>
        <option value="physician">Physician</option>
        <option value="nurse">Travel Nurse</option>
        <option value="recruiter">Recruiter/Employer</option>
        <option value="other">Other</option>
      </select>

      {isRecruiter && (
        <div className="space-y-4">
          <input
            type="text"
            name="agency"
            value={formData.agency}
            onChange={handleChange}
            placeholder="Agency/Facility"
            className="w-full p-3 rounded-lg bg-gray-900 border border-gray-700 text-white placeholder-gray-500 focus:border-purple-500 focus:ring-purple-500"
            required
          />
          <input
            type="website"
            name="website"
            value={formData.website}
            onChange={handleChange}
            placeholder="Company Website"
            className="w-full p-3 rounded-lg bg-gray-900 border border-gray-700 text-white placeholder-gray-500 focus:border-purple-500 focus:ring-purple-500"
          />
        </div>
      )}

      <button
        type="submit"
        className="bg-gradient-to-r from-purple-500 to-amber-500 px-8 py-4 rounded-lg text-white font-medium text-lg hover:opacity-90 transition-opacity"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Submitting..." : "Join Waitlist Now"}
      </button>

      {successMessage && <p className="text-green-500 text-sm mt-2">{successMessage}</p>}
      <p className="text-gray-400 text-sm">© {new Date().getFullYear()} Trvllr™. All rights reserved.</p>
    </form>
  );
};

export default WaitlistForm;
